<template>
  <b-container fluid class="rounded contents p-4 mx-3">
    <section class="p-4">
      <router-link tag="b" to="details" class="btn btn-ghost go-back-btn shadow-none px-0 mb-3 d-flex align-items-center">
        <img src="@/assets/images/arrow-back.svg" alt="Go Back" class="mr-2">
        Go Back
      </router-link>
      <BillingDetailsForm />
    </section>
    <ConfirmSaveCreditCard />
    <XenditPromptModal :message="xenditMessage" />
    <XenditAuthenticationModal
      :isOpenAuthenticationModal="isOpenAuthenticationModal"
      :authenticationUrl="authenticationUrl"
    />
  </b-container>
</template>

<script>
import BillingDetailsForm from "@/components/my-plan/BillingDetailsForm";
import ConfirmSaveCreditCard from "@/components/my-plan/ConfirmSaveCreditCard";
import XenditPromptModal from "@/components/my-plan/XenditPromptModal";
import XenditAuthenticationModal from "@/components/my-plan/XenditAuthenticationModal";
import "@/plugins/vue-head";

export default {
  name: "AddCreditCardDetails",
  components: {
    BillingDetailsForm,
    ConfirmSaveCreditCard,
    XenditPromptModal,
    XenditAuthenticationModal
  },
  head: {
    script: function() {
      return [{
        type: 'text/javascript',
        src: 'https://js.xendit.co/v1/xendit.min.js'
      }];
    }
  },
  data() {
    return {
      xenditMessage: null,
      isOpenAuthenticationModal: false,
      authenticationUrl: null
    }
  },
  mounted() {
    this.$root.$on('showXenditPromptModal', ({ message }) => {
      this.xenditMessage = message;
      this.$root.$emit('bv::show::modal', 'xendit-prompt-modal');
    });
    this.$root.$on('setAuthenticationConfigs', ({ isOpenAuthenticationModal, authenticationUrl }) => {
      this.isOpenAuthenticationModal = isOpenAuthenticationModal;
      this.authenticationUrl = authenticationUrl;
    });
  },
  beforeDestroy() {
    this.$root.$off('showXenditPromptModal');
    this.$root.$off('setAuthenticationConfigs');
  }
}
</script>

<style lang="scss" scoped>
.btn.btn-ghost.go-back-btn {
  color: #5182FF;
  font-size: 14px;
  font-family: MainFontBold, sans-serif;
}
#save-alert {
  background: #2f4858;
  .alert-action-buttons {
    .btn-primary {
      border-radius: 20px;
    }
    .btn-ghost:focus-visible {
      outline: 0 !important;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
